import React, { SyntheticEvent } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Grid from "@mui/material/Grid";
import { Divider } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";

import PrimaryText from "./PrimaryText";
import { styled } from "@mui/material";


const CustomListWrapper = styled("div")(({ theme }) => {
  return {
    width: "100%",
    "&.pointer-events-none": {
      pointerEvents: "none",
    },
    ".cursor-hand-hover": {
      cursor: "pointer",
    },
    ".MuiListItem-root.disabled .only-description": {
      color: "#ccc",
    },
    "& .MuiListItem-root": {
      ".list-item-img": {
        minWidth: 45,
      },
      img: {
        width: 36,
      },
      padding: "0px 10px",
    },
    "& .MuiGrid-item": {
      width: "100%",
    },
    ".only-description": {
      padding: "7px 10px",
      display: "block",
      fontSize: "1vw",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "1.2",
      letterSpacing: ".15px",
      color: "#4f4f4f",
    },
    ".MuiListItemText-secondary": {
      color: "rgb(78, 78, 78)",
      fontWeight: 500,
      fontSize: 12,
    },
    ".label-warapper": {
      textTransform: "uppercase",
      fontSize: 12,
      marginBottom: 5,
      fontWeight: 400,
      lineHeight: 1,
      letterSpacing: 0.15,
      color: "#8c827a",
    },
    [theme.breakpoints.down(770)]: {
      ".only-description": {
        fontSize: "2.5vw",
      },
    },
    [theme.breakpoints.down(575)]: {
      ".only-description": {
        fontSize: 13,
      },
    },
  };
});

export const InteractiveList = (
  props
) => {
  return (
    <CustomListWrapper
      className={`list-wrapper ${!props?.onClick ? "pointer-events-none" : ""}`}
      style={{width:'400px'}}
    >
      <Grid container>
        <Grid item xs={12} md={12}>
          <List disablePadding>
            {props.list?.map((data, index) => {
              return (
                <div key={`${data.label}-${index}`}>
                  <ListItem
                    className={
                      props?.onClick && !data.disable
                        ? "cursor-hand-hover"
                        : "disabled"
                    }
                    disableGutters
                    onClick={(event) =>
                      !data.disable && props?.onClick?.(data)
                    }
                  >
                    {data.image ? (
                      <ListItemIcon className="list-item-img">
                        <img src={data.image} alt={`${data.label}`} />
                      </ListItemIcon>
                    ) : null}
                    <ListItemText
                      primary={<PrimaryText {...data} />}
                      secondary={
                        <span
                          title={data?.description ? data?.description:""}
                          className={data.label ? "" : "only-description"}
                        >
                          {data?.description ? data?.description:""}
                        </span>
                      }
                    />
                  </ListItem>
                  {!data.label || index === props.list.length - 1 ? null : (
                    <Divider />
                  )}
                </div>
              );
            })}
          </List>
        </Grid>
      </Grid>
    </CustomListWrapper>
  );
};
